'use strict';

/**
 * @name createBudgetButton Directive
 * @desc Directive for handling create budget button logic
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular
  .module('metabuyer')
  .directive('createBudgetButton', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/budget/createBudgetButton/createBudgetButton.html',
      scope: {},
      controller: function ($scope, $rootScope, $state, UserPermissions, budgets, globalFunc) {
        $scope.disabled = false;
        $scope.title = 'Create Budget';
        $scope.listOfCompanies = UserPermissions.getBudgetCompanies($rootScope.currentUser, 'C');

        $scope.createBudget = createBudget;
        $scope.showCreateButton = showCreateButton;

        /**
         * navigate to creation page
         */
        function createBudget(company) {
          $scope.title = 'Loading ...';
          $scope.disabled = true;
          budgets.post(
            {
              company_code: company.code
            },
            function (resource) {
              enableCreateButton();
              if (!!resource.content && !!resource.content.data) {
                var data = resource.content.data;
                $state.go('main.user.budget.details', {id: data._id});
              }
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
              enableCreateButton();
            }
          );
        }

        /**
         * This function enable the create button
         */
        function enableCreateButton () {
          $scope.title = 'Create Budget';
          $scope.disabled = false;
        }

        /**
         * This function return a boolean to show or hiding the create budget button
         * @returns boolean
         */
        function showCreateButton() {
          return $state.current.name.indexOf('budget') > -1;
        }
      }
    };
  });
